"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCurrentUserProfilePicture = void 0;
exports.selectProfilePicture = selectProfilePicture;
exports.selectProfilePicturesMap = selectProfilePicturesMap;
/* eslint-disable @typescript-eslint/no-explicit-any */
var immutable_1 = require("immutable");
var toolkit_1 = require("@reduxjs/toolkit");
var config_1 = require("config");
var config = (0, config_1.get)();
var communityProfileEnabled = !!(config && config.features
    && config.features.communityProfile);
var EMPTY_PICTURE = { url: '', small: '', card: '' };
var EMPTY_MAP = (0, immutable_1.Map)();
// Cache the last toJS() conversion per uid to avoid creating new references
// when the underlying Immutable data hasn't changed.
var _toJsCache = new immutable_1.Map();
/**
 * Select a profile picture for a given uid from the GraphQL lookup table.
 *
 * Feature-flag gated:
 *   ON  → returns { url, small, card } (empty strings if not yet loaded)
 *   OFF → returns null (callers use their existing REST paths)
 */
function selectProfilePicture(state, uid) {
    if (!communityProfileEnabled)
        return null;
    if (!uid)
        return EMPTY_PICTURE;
    var key = String(uid);
    var gql = state.communityProfile.getIn(['profilePictures', 'data', key]);
    if (gql && gql.size > 0) {
        var cached = _toJsCache.get(key);
        if (cached && cached.source === gql) {
            return cached.result;
        }
        var result = gql.toJS();
        _toJsCache.set(key, { source: gql, result: result });
        return result;
    }
    return EMPTY_PICTURE;
}
var selectAuthUid = function (state) { return state.auth.get('uid'); };
var selectProfilePicturesData = function (state) { return state.communityProfile.getIn(['profilePictures', 'data']); };
/**
 * Memoized selector for the current user's profile picture.
 * Uses createSelector so the derived .toJS() object is referentially stable
 * across renders when the underlying Immutable data hasn't changed.
 */
exports.selectCurrentUserProfilePicture = (0, toolkit_1.createSelector)([selectAuthUid, selectProfilePicturesData], function (uid, data) {
    if (!communityProfileEnabled)
        return null;
    if (!uid)
        return EMPTY_PICTURE;
    var key = String(uid);
    var gql = data ? data.get(key) : undefined;
    if (gql && gql.size > 0) {
        return gql.toJS();
    }
    return EMPTY_PICTURE;
});
/**
 * Select the entire profilePictures lookup Map for multi-profile components.
 *
 * Feature-flag gated:
 *   ON  → returns Immutable Map keyed by uid string
 *   OFF → returns empty Map (callers fall back to REST paths)
 */
function selectProfilePicturesMap(state) {
    if (!communityProfileEnabled)
        return EMPTY_MAP;
    return state.communityProfile.getIn(['profilePictures', 'data'], EMPTY_MAP);
}
